import { Ref } from 'vue'
import dataStorageManager, { BucketDefaultIDs, DMS_Operation } from '../../managers/data/DataStorageManager'
import dataQueryManager from '../../managers/network/DataQueryManager'
import { emailify, rutify } from '../apiUtils'
import { IRequest } from './RequestsServices'
import identityManager, { LoggedInUser } from '../../managers/identity/IdentityManager'
import { IUser } from './UsersServices'

export enum IncidenceType {
  USUARIO = 0,
  ARMADOR = 1,
  EMBARCACION = 2,
  TRIPULANTE = 3,
  PROVEEDOR = 4,
  VIAJE = 5,
  SERVICIO = 6,
  COBRO = 7,
  REPORTE = 8,
  TARIFA = 9,
  PREACREDITACION = 10,
  HORARIO = 11,
  ROL_ALTERNATIVO = 12,
  REPRESENTANTE = 13,
  ESPORADICO = 14,
}

export const incidenceTypeLabel = (type: IncidenceType): string => {
  switch (type) {
    case IncidenceType.USUARIO:
      return 'Usuario'
    case IncidenceType.ARMADOR:
      return 'Armador'
    case IncidenceType.EMBARCACION:
      return 'Embarcación'
    case IncidenceType.TRIPULANTE:
      return 'Tripulante'
    case IncidenceType.PROVEEDOR:
      return 'Proveedor'
    case IncidenceType.VIAJE:
      return 'Viaje'
    case IncidenceType.SERVICIO:
      return 'Servicio'
    case IncidenceType.COBRO:
      return 'Cobro'
    case IncidenceType.REPORTE:
      return 'Reporte'
    case IncidenceType.TARIFA:
      return 'Tarifa'
    case IncidenceType.PREACREDITACION:
      return 'Preacreditación'
    case IncidenceType.HORARIO:
      return 'Horario'
    case IncidenceType.ROL_ALTERNATIVO:
      return 'Rol Alternativo'
    case IncidenceType.REPRESENTANTE:
      return 'Representante'
    case IncidenceType.ESPORADICO:
      return 'Esporádico'
    default:
      return 'Desconocido'
  }
}

export const IncidenceTypeOptions = [
  { label: 'Usuario', value: IncidenceType.USUARIO },
  { label: 'Armador', value: IncidenceType.ARMADOR },
  { label: 'Embarcación', value: IncidenceType.EMBARCACION },
  { label: 'Tripulante', value: IncidenceType.TRIPULANTE },
  { label: 'Proveedor', value: IncidenceType.PROVEEDOR },
  { label: 'Viaje', value: IncidenceType.VIAJE },
  { label: 'Servicio', value: IncidenceType.SERVICIO },
  { label: 'Cobro', value: IncidenceType.COBRO },
  { label: 'Reporte', value: IncidenceType.REPORTE },
  { label: 'Tarifa', value: IncidenceType.TARIFA },
  { label: 'Preacreditación', value: IncidenceType.PREACREDITACION },
  { label: 'Horario', value: IncidenceType.HORARIO },
  { label: 'Rol Alternativo', value: IncidenceType.ROL_ALTERNATIVO },
  { label: 'Apoderado', value: IncidenceType.REPRESENTANTE },
  { label: 'Esporádico', value: IncidenceType.ESPORADICO },
]

export enum IncidenceCode {
  CREACION = 'CREACION',
  SOLICITUD_CREACION = 'SOLICITUD_CREACION',
  MODIFICACION = 'MODIFICACION',
  SOLICITUD_MODIFICACION = 'SOLICITUD_MODIFICACION',
  APROBACION = 'APROBACION',
  RECHAZO = 'RECHAZO',
  INACTIVACION = 'INACTIVACION',
  CANCELACION = 'CANCELACION',
  ASOCIACION = 'ASOCIACION',
  SOLICITUD_ASOCIACION = 'SOLICITUD_ASOCIACION',
  DESASOCIACION = 'DESASOCIACION',
  POSICION = 'POSICION',
  MARCA_INICIO = 'MARCA_INICIO',
  LIMPIEZA_MARCA_INICIO = 'LIMPIEZA_MARCA_INICIO',
  MARCA_FIN = 'MARCA_FIN',
  LIMPIEZA_MARCA_FIN = 'LIMPIEZA_MARCA_FIN',
  MARCA_SALIDA = 'MARCA_SALIDA',
  CIERRE = 'CIERRE',
  REPETIR_VIAJE = 'REPETIR_VIAJE',
  AGREGAR_TRIPULANTE = 'AGREGAR_TRIPULANTE',
  CAMBIO_MUELLE = 'CAMBIO_MUELLE',
  DESACREDITACION = 'DESACREDITACION',
  REACREDITACION = 'REACREDITACION',
  DESIGNACION = 'DESIGNACION',
  REVOCACION = 'REVOCACION',
  CONFIGURACION_PERMISOS = 'CONFIGURACION_PERMISOS',
}

export const incidenceCodeLabel = (code: IncidenceCode): string => {
  switch (code) {
    case IncidenceCode.CREACION:
      return 'Creación'
    case IncidenceCode.SOLICITUD_CREACION:
      return 'Solicitud de creación'
    case IncidenceCode.MODIFICACION:
      return 'Modificación'
    case IncidenceCode.SOLICITUD_MODIFICACION:
      return 'Solicitud de modificación'
    case IncidenceCode.APROBACION:
      return 'Aprobación'
    case IncidenceCode.RECHAZO:
      return 'Rechazo'
    case IncidenceCode.INACTIVACION:
      return 'Inactivación'
    case IncidenceCode.CANCELACION:
      return 'Cancelación'
    case IncidenceCode.ASOCIACION:
      return 'Asociación'
    case IncidenceCode.SOLICITUD_ASOCIACION:
      return 'Solicitud de asociación'
    case IncidenceCode.DESASOCIACION:
      return 'Desasociación'
    case IncidenceCode.POSICION:
      return 'Posición'
    case IncidenceCode.MARCA_INICIO:
      return 'Marca de inicio'
    case IncidenceCode.LIMPIEZA_MARCA_INICIO:
      return 'Limpieza de marca de inicio'
    case IncidenceCode.MARCA_FIN:
      return 'Marca de fin'
    case IncidenceCode.LIMPIEZA_MARCA_FIN:
      return 'Limpieza de marca de fin'
    case IncidenceCode.MARCA_SALIDA:
      return 'Marca de salida'
    case IncidenceCode.CIERRE:
      return 'Cierre'
    case IncidenceCode.REPETIR_VIAJE:
      return 'Repetir viaje'
    case IncidenceCode.CAMBIO_MUELLE:
      return 'Cambio de muelle'
    case IncidenceCode.DESACREDITACION:
      return 'Desacreditación'
    case IncidenceCode.REACREDITACION:
      return 'Reacreditación'
    case IncidenceCode.DESIGNACION:
      return 'Designación'
    case IncidenceCode.REVOCACION:
      return 'Revocación'
    case IncidenceCode.CONFIGURACION_PERMISOS:
      return 'Configuración de permisos'
    default:
      return 'Desconocido'
  }
}

export const IncidenceCodeOptions = [
  { label: 'Creación', value: IncidenceCode.CREACION },
  { label: 'Solicitud de creación', value: IncidenceCode.SOLICITUD_CREACION },
  { label: 'Modificación', value: IncidenceCode.MODIFICACION },
  { label: 'Solicitud de modificación', value: IncidenceCode.SOLICITUD_MODIFICACION },
  { label: 'Aprobación', value: IncidenceCode.APROBACION },
  { label: 'Rechazo', value: IncidenceCode.RECHAZO },
  { label: 'Inactivación', value: IncidenceCode.INACTIVACION },
  { label: 'Cancelación', value: IncidenceCode.CANCELACION },
  { label: 'Asociación', value: IncidenceCode.ASOCIACION },
  { label: 'Solicitud de asociación', value: IncidenceCode.SOLICITUD_ASOCIACION },
  { label: 'Desasociación', value: IncidenceCode.DESASOCIACION },
  { label: 'Posición', value: IncidenceCode.POSICION },
  { label: 'Marca de inicio', value: IncidenceCode.MARCA_INICIO },
  { label: 'Limpieza de marca de inicio', value: IncidenceCode.LIMPIEZA_MARCA_INICIO },
  { label: 'Marca de fin', value: IncidenceCode.MARCA_FIN },
  { label: 'Limpieza de marca de fin', value: IncidenceCode.LIMPIEZA_MARCA_FIN },
  { label: 'Marca de salida', value: IncidenceCode.MARCA_SALIDA },
  { label: 'Cierre', value: IncidenceCode.CIERRE },
  { label: 'Repetir viaje', value: IncidenceCode.REPETIR_VIAJE },
  { label: 'Cambio de muelle', value: IncidenceCode.CAMBIO_MUELLE },
  { label: 'Desacreditación', value: IncidenceCode.DESACREDITACION },
  { label: 'Reacreditación', value: IncidenceCode.REACREDITACION },
  { label: 'Designación', value: IncidenceCode.DESIGNACION },
  { label: 'Revocación', value: IncidenceCode.REVOCACION },
  { label: 'Configuración de permisos', value: IncidenceCode.CONFIGURACION_PERMISOS },
]

export interface IIncidencia {
  id: number
  codigo_incidencia: IncidenceCode
  tipo_incidencia_id: IncidenceType
  fecha_incidencia: string
  autor: number
  descripcion: string
  id_objeto: number
  usuario_registro: number
  fecha_creacion: string
  fecha_resolucion: string
  activo: boolean
}

export interface OperatedIncidencia extends IIncidencia {
  autorData: IUser | undefined
}

export const defaultIIncidencia: IIncidencia = {
  id: 0,
  codigo_incidencia: IncidenceCode.CREACION,
  tipo_incidencia_id: IncidenceType.ARMADOR,
  fecha_incidencia: new Date().toISOString(),
  autor: 0,
  descripcion: '',
  id_objeto: 0,
  usuario_registro: 0,
  fecha_creacion: new Date().toISOString(),
  fecha_resolucion: new Date().toISOString(),
  activo: true,
}

export default class BitacoraServices {
  private bucketID: string | null = null

  constructor() {
    // Registrar el bucket para cambios
    this.bucketID = dataStorageManager.registerBucket<IIncidencia>(
      this.getAllIncidences.bind(this), // Asegúrate de enlazar el contexto correcto
      {
        refreshRatio: 5 * 60 * 1000, // Refrescar cada 5 minutos
        //preload: true, // Preload
        bucketID: BucketDefaultIDs.BITACORA, // ID del bucket
        operations: new Map<string, DMS_Operation>([
          [
            'insertIncidencia',
            {
              operation: this.insertIncidencia.bind(this),
              reloadAfter: true,
            },
          ],
        ]), // Las operaciones se añadiran despues
      },
    )
  }

  startup() {}

  async getAllIncidences(): Promise<IIncidencia[]> {
    try {
      const response = await dataQueryManager.addQuery<IIncidencia | IIncidencia[]>({
        query: `${import.meta.env.VITE_BASE_URL}/bitacora/1/op_select_bitacora_incidencias`,
        operation: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        params: [],
      })
      if (response.data && Array.isArray(response.data)) {
        return response.data // Filter valid changes
      } else if (response.data) {
        return [response.data]
      }
    } catch (error) {
      console.error('Error fetching cambios:', error)
    }
    return []
  }

  async insertIncidencia(incidenceData: Omit<IIncidencia, 'id' | 'fecha_creacion'>): Promise<boolean> {
    try {
      const currentUser: LoggedInUser | null = identityManager.getUser()

      if (currentUser) {
        const body = {
          op_insert_bitacora_incidencias: {
            codigo_incidencia: incidenceData.codigo_incidencia,
            tipo_incidencia_id: incidenceData.tipo_incidencia_id,
            fecha_incidencia: new Date().toISOString(),
            autor: currentUser.id_usuario,
            descripcion: incidenceData.descripcion,
            id_objeto: incidenceData.id_objeto,
            usuario_registro: currentUser.id_usuario,
            fecha_resolucion: new Date().toISOString(),
            activo: true,
          },
        }
        const response = await dataQueryManager.addQuery<number>({
          query: `${import.meta.env.VITE_BASE_URL}/bitacora/1/op_insert_bitacora_incidencias`,
          operation: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          params: [],
          body: body,
        })
        if (response.data && typeof response.data === 'number') {
          return true
        }
      }
    } catch (error) {
      console.error('Error inserting cambios:', error)
    }
    return false
  }
}
